import * as React from 'react';

import { IconSort } from 'basics/icons';
import ContentPlaceholder from 'basics/loaders/ContentPlaceholder/ContentPlaceholder';
import { Bar } from 'basics/loaders/ContentPlaceholder/ContentPlaceholder.styled';

import { REWARD_LABELS } from './RewardsList.constants';
import { LoadingMarket, LoadingPair, LoadingMarketText } from './RewardsList.styled';
import { Cell, Head, Row } from './RewardsTableLoading.styled';

// Keep this shell independent of Table: its virtual scrolling code belongs in the lazy route.
const RewardsTableLoading = () => (
    <ContentPlaceholder label="Loading market rewards">
        <Head aria-hidden="true">
            <Cell $market>Market</Cell>
            {REWARD_LABELS.map(label => (
                <Cell key={label}>
                    {label}
                    <IconSort isEnabled={false} isReversed={false} />
                </Cell>
            ))}
        </Head>
        {Array.from({ length: 5 }, (_, index) => (
            <Row key={index} aria-hidden="true">
                <Cell $market>
                    <LoadingMarket>
                        <LoadingPair>
                            <Bar $width="3.2rem" $height="3.2rem" $circle />
                            <Bar $width="3.2rem" $height="3.2rem" $circle />
                        </LoadingPair>
                        <LoadingMarketText>
                            <Bar $width="9rem" $height="1.6rem" />
                            <Bar $width="7rem" $height="1.2rem" />
                        </LoadingMarketText>
                    </LoadingMarket>
                </Cell>
                {REWARD_LABELS.map(label => (
                    <Cell key={label}>
                        <span>{label}</span>
                        <Bar $width="12rem" $height="1.4rem" />
                    </Cell>
                ))}
            </Row>
        ))}
    </ContentPlaceholder>
);

export default RewardsTableLoading;
